import React from 'react';

import { PartnerHero } from './PartnerHero';
import { PartnerPortal } from './PartnerPortal';
import { PartnershipTiers } from './PartnershipTiers';
import { PartnerSupportCollaborate } from './PartnerSupportCollaborate';

import './PartnerWithUs.css';

export const PartnerWithUs = ({ user, token, isSubmitted, loading }) => {
  return (
    <div className="partner-with-us-container">
      <PartnerHero user={user} token={token} loading={loading} isSubmitted={isSubmitted} />
      <PartnerPortal />
      <PartnerSupportCollaborate />
      <PartnershipTiers />
    </div>
  );
};
